import React, { useEffect, useRef, useState } from "react";

import { Slide, Slider, Container, DotsContainer, Dot } from "./styles";

import { BannerHome } from "../Banners";

interface IHomeBanner {
  homeCarouselBanners: {
    id: number;
    url: string;
    mobile_url: string;
    buttons: boolean;
  }[];
}

export const CarouselBannerHome: React.FC = () => {
  const interval = 4000;
  const [current, setCurrent] = useState(0);
  const [bannersHomeCarousel, setBannersHomeCarousel] = useState<IHomeBanner | undefined>();

  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    timerRef.current = setInterval(() => {
      setCurrent(
        (prev) => (prev + 1) % (bannersHomeCarousel?.homeCarouselBanners?.length || 1)
      );
    }, interval);
  };

  useEffect(() => {
    resetTimer();
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannersHomeCarousel?.homeCarouselBanners?.length, interval]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch(
          "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/home-carousel-banners.json/beautify"
        );
        //@ts-ignore
        const data: ResponseType = await response.json();

        setBannersHomeCarousel(data as any);
      } catch (e) {
        console.error(e);
      }
    };
    fetchBanners();
  }, []);

  return (
    <Container>
      <Slider style={{ transform: `translateX(-${current * 100}%)` }}>
        {bannersHomeCarousel?.homeCarouselBanners?.map((banner, index) => (
          <Slide key={index}>
            <BannerHome
              img={banner.url}
              alt="Banner da página inicial. O componente carrossel passa automaticamente várias imagens."
              text={banner.buttons}
              imgMobile={banner.mobile_url}
            />
          </Slide>
        ))}
      </Slider>

      <DotsContainer>
        {bannersHomeCarousel?.homeCarouselBanners?.map((_, index) => (
          <Dot
            key={index}
            active={index === current}
            onClick={() => {
              setCurrent(index);
              resetTimer();
            }}
          />
        ))}
      </DotsContainer>
    </Container>
  );
};
